import React, { useEffect, useRef } from "react";
import "./SectionHistoire.css";
import { FaFutbol, FaUsers, FaTrophy } from 'react-icons/fa';
import {Link} from "react-router-dom";

const SectionHistoire = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                        observer.unobserve(entry.target); // Arrête l'observation une fois animé
                    }
                });
            },
            { threshold: 0.2 } // Animation déclenchée quand 20% de la section est visible
        );

        const elementsToAnimate = sectionRef.current.querySelectorAll(".animate-on-visible");
        elementsToAnimate.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <section className="section-histoire" ref={sectionRef} data-aos="slide-zoom-in">
            <div className="histoire-content animate-on-visible">
                <h2 className="histoire-title">Notre Histoire et Nos Valeurs</h2>
                <p className="histoire-description">
                    Fondé en 2008, le Nantes Doulon Bottière Futsal incarne l'esprit de sport collectif. Notre mission est de promouvoir les valeurs de respect, unité et excellence à travers le futsal. Rejoignez-nous dans cette aventure !
                </p>
                <Link to="/club">
                    <button className="histoire-button">En savoir plus</button>
                </Link>
            </div>
            <div className="valeurs-container animate-on-visible">
                <div className="valeur-card">
                    <FaFutbol size={50} color="white"/>
                    <h3 className="valeur-title">Sport</h3>
                </div>
                <div className="valeur-card">
                    <FaTrophy size={50} color="white"/>
                    <h3 className="valeur-title">Excellence</h3>
                </div>
                <div className="valeur-card">
                    <FaUsers size={50} color="white"/>
                    <h3 className="valeur-title">Unité</h3>
                </div>
            </div>
        </section>
    );
};

export default SectionHistoire;

